import React from 'react';
import LoadingData from 'components/loading-data';
import ArrowIcon from 'components/icon/arrow-icon';
import configJSON from 'config.json';
import { listingCardIds } from 'constants/test-constants';
import styles from './style.module.scss';
import { useUserContext } from 'contexts';
import { fetchHomePageListings } from 'components/home-page/fetcher';
import { AVAILABLE_STATUS } from 'contexts/preferences/listing-params/types';
import { defaultHomeType } from 'constants/listing-components';
import { AreaPageListingCardData } from 'components/pages/area-listings/area_page_listing_card_data';
import { useOnListingCardClick } from 'utils/listing-card';
import NearbyHomesCarousel from 'components/pages/team/nearby-listings';
import { TenantIds } from '@tenants';
import { serverSideTranslations } from 'next-i18next/serverSideTranslations';
import { Namespaces } from 'types/locales';
import type { GetServerSideProps } from 'next';

export default function NearbyListings() {
  const { userLocation: location } = useUserContext();
  const userAreaLink = `${configJSON.host}/${location?.slug}-real-estate`;

  const onListingCardClick = useOnListingCardClick();

  const getNearbyHomes = async () => {
    const { listings } = await fetchHomePageListings({
      country: location?.countryCode,
      slug: location?.slug || '',
      filter: {
        status: AVAILABLE_STATUS,
        homeType: defaultHomeType,
        hasImage: true,
        tenant: TenantIds.ZOOCASA,
      },
      pageSize: 5,
      isClient: true,
      useLegacySearchFilter: false,
    });
    return listings.map(listing => new AreaPageListingCardData(listing));
  };

  return (
    <div className={styles.component} data-testid={listingCardIds.nearbyListings}>
      <div className={styles.header}>
        <h2>Listings Near You</h2>
        <a href={userAreaLink} target="_blank" rel="noreferrer" data-testid={listingCardIds.nearbyViewMore}>View More <ArrowIcon /></a>
      </div>
      <LoadingData promise={getNearbyHomes()} emptyState='No homes near you'>
        {listings => <NearbyHomesCarousel listings={listings} location={location} onListingCardClick={onListingCardClick} />}
      </LoadingData>
    </div>
  );
}

export const getServerSideProps: GetServerSideProps = async ({ locale }) => {
  return {
    props: {
      ...(await serverSideTranslations(locale ?? 'en', [Namespaces.COMMON])),
    },
  };
};
